module.exports = __webpack_public_path__ + "static/media/lightning.b80d2053.png";